// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3zy9L","notes":"Notes_notes__2Qkg_","note":"Notes_note__36j0c","markdown":"Notes_markdown__31Wvr"};